import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { showModal } from "../features/modal/modalSlice"
import { modal } from "../features/modal/modalTypes"
import { AppDispatch } from "../redux/store"
import { useChangelogSeen } from "../util/useChangelogSeen"

export const NewFeaturesButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>()
  const { hasNew, markSeen } = useChangelogSeen()

  const handleClick = () => {
    markSeen()
    dispatch(showModal(modal("features")))
  }

  return (
    <button
      className={`button is-dark${hasNew ? " has-notification-dot" : ""}`}
      title={t("tooltip.changeLog")}
      onClick={handleClick}
    >
      <span className="icon is-medium">
        <i className={`icon-gift is-large${hasNew ? " new" : ""}`} aria-hidden="true"></i>
      </span>
    </button>
  )
}
